import React, { useState } from "react";
import "../../../assets/styles/feedback-section.scss";

type FeedbackSectionProps = {
  titleLight?: string;
  titleAccent?: string;
  description?: string;
  mapSrc?: string;                // Google Maps embed URL
  onSubmit?: (data: {
    name: string;
    email: string;
    subject: string;
    message: string;
  }) => void;
  maxWidth?: number | string;
  accentColor?: string;           // default #2ba87a"(yeşil)
};

const FeedbackSection: React.FC<FeedbackSectionProps> = ({
  titleLight = "Görüşlerinizi",
  titleAccent = "Bize Bildirin",
  description = "Sizin görüşleriniz bizim için çok önemli. Görüşlerinizi, istek, dilek ve şikayetlerinizi bizimle paylaşın. Sizin memnuniyetiniz öncelikli görevimizdir.",
  mapSrc = "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3049.770528931013!2d36.925!3d37.581!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zT8O8ZWwgTWVnYVBhcmsgSGFzdGFuZXNp!5e0!3m2!1str!2str!4v1700000000000",
  onSubmit,
  maxWidth = 1200,
  accentColor = "#2ba87a",
}) => {
  const [form, setForm] = useState({
    name: "",
    email: "",
    subject: "",
    message: "",
  });
  const [emailError, setEmailError] = useState<string>("");
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/i;

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { name, value } = e.target;
    setForm(prev => ({ ...prev, [name]: value }));
    if (name === 'email') {
      if (!value) {
        setEmailError('E-posta zorunludur.');
      } else if (!emailRegex.test(value)) {
        setEmailError('Lütfen geçerli bir e-posta adresi giriniz.');
      } else {
        setEmailError('');
      }
    }
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // basit doğrulama
    let hasError = false;
    if (!form.email || !emailRegex.test(form.email)) {
      setEmailError(!form.email ? 'E-posta zorunludur.' : 'Lütfen geçerli bir e-posta adresi giriniz.');
      hasError = true;
    }
    if (hasError) return;
    onSubmit?.(form);
    // gönderimden sonra temizle
    setForm({ name: "", email: "", subject: "", message: "" });
    setEmailError("");
  };

  return (
    <section
      className="feedback-section"
      style={{ 
        // @ts-ignore
        "--fs-accent": accentColor, 
        // @ts-ignore
        "--fs-maxw": typeof maxWidth === "number" ? `${maxWidth}px` : maxWidth 
      }}
    >
      <div className="fs-container">
        {/* Başlık */}
        <header className="fs-head">
          <h2 className="fs-title">
            <span className="light">{titleLight}</span>{" "}
            <span className="accent">{titleAccent}</span>
          </h2>
          <p className="fs-desc">{description}</p>
        </header>

        {/* İçerik Alanı */}
        <div className="fs-grid">
          {/* MAP */}
          <div className="fs-map">
            <div className="map-embed">
              {/* <iframe
                src={mapSrc}
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="Harita"
              /> */}

              <iframe
                src={mapSrc}
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                allowFullScreen
                title="Harita"
              ></iframe>
            </div>
          </div>

          {/* FORM */}
          <div className="fs-form">
            <form onSubmit={handleSubmit} noValidate>
              <label className="fs-label">
                Ad ve Soyadınız <span className="req">*</span>
                <input
                  type="text"
                  name="name"
                  placeholder="Adınız Soyadınız"
                  value={form.name}
                  onChange={handleChange}
                  required
                />
              </label>

              <label className="fs-label">
                E-posta <span className="req">*</span>
                <input
                  type="email"
                  name="email"
                  placeholder="ornek@eposta.com"
                  value={form.email}
                  onChange={handleChange}
                  required
                  aria-invalid={!!emailError}
                  className={emailError ? 'invalid' : undefined}
                />
                {emailError && (
                  <div style={{ color: '#e11d48', fontSize: 12, marginTop: 4 }} role="alert">
                    {emailError}
                  </div>
                )}
              </label>

              <label className="fs-label">
                Konu
                <input
                  type="text"
                  name="subject"
                  placeholder="Konu başlığı"
                  value={form.subject}
                  onChange={handleChange}
                />
              </label>

              <label className="fs-label">
                Mesajınız
                <textarea
                  name="message"
                  placeholder="Mesajınızı buraya yazın…"
                  rows={7}
                  value={form.message}
                  onChange={handleChange}
                />
              </label>

              <div className="fs-actions">
                <button type="submit" className="fs-submit">
                  Gönder
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FeedbackSection;
